import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initMonitoring } from './monitoring';
import '@ui/tokens.css';

initMonitoring();

const container = document.getElementById('root');
if (!container) throw new Error('Root element missing from the document.');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
